import { MaskedInput } from 'rsuite';
import React, { useState } from 'react';

const DebouncedDurationField = ({ onChange, value}) => {

    const parseTimeString = (value) => {
        const hours = Number(value.substring(0, 2));
        const parsedMinutes = Number(value.substring(3,5));
        const roundedMinutes = Math.ceil(parsedMinutes / 15) * 15;
        const minutes = roundedMinutes >= 60 ? 0 : roundedMinutes;
        return hours + minutes / 60.0;
    }

    const getTimeString = (value) => {
        const setTwoDigits = (num) => `0${Math.floor(num)}`.slice(-2);
        const hours = setTwoDigits(value);
        const minutes = setTwoDigits((value * 60) % 60);
        return `${hours}:${minutes}`;
    };

    const [displayedValue, setDisplayedValue] = useState(getTimeString(value));
    const [debounceTimeout, setDebounceTimeout] = useState(0);

    const onValueChange = (newValue) => {
        clearTimeout(debounceTimeout);
        setDebounceTimeout(setTimeout(() => {
            const parsedValue = parseTimeString(newValue);
            onChange(parsedValue);
            setDisplayedValue(getTimeString(parsedValue));
        }, 500));
        setDisplayedValue(newValue);
    };
    
    return (
        <MaskedInput
            value={displayedValue}
            mask={[/\d/,/\d/,":",/\d/,/\d/]}
            showMask
            placeholderChar="0"
            guide
            keepCharPositions
            style={{height: 38}}
            onChange={onValueChange}
        />
    );
};

export default DebouncedDurationField;